export default __webpack_public_path__ + "static/media/ico-fb.1ff13ebc.svg";